/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProfileSummary } from './';
import {
    ProfileSummaryFromJSON,
    ProfileSummaryFromJSONTyped,
    ProfileSummaryToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancersList
 */
export interface FreelancersList {
    /**
     * Identifier of the list
     * @type {string}
     * @memberof FreelancersList
     */
    id: string;
    /**
     * Name of the list
     * @type {string}
     * @memberof FreelancersList
     */
    name?: string;
    /**
     * Full name of the list owner
     * @type {string}
     * @memberof FreelancersList
     */
    ownerFullName?: string;
    /**
     * Whether the list is shared within the company or private
     * @type {boolean}
     * @memberof FreelancersList
     */
    sharedWithinCompany: boolean;
    /**
     * The details about the first profiles in the list
     * @type {Array<ProfileSummary>}
     * @memberof FreelancersList
     */
    firstProfiles: Array<ProfileSummary>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FreelancersList
     */
    profiles: Array<string>;
    /**
     * Number of freelancers in the list
     * @type {number}
     * @memberof FreelancersList
     */
    count: number;
}

/**
 * Check if a given object implements the FreelancersList interface.
 */
export function instanceOfFreelancersList(value: object): value is FreelancersList {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('sharedWithinCompany' in value) || value['sharedWithinCompany'] === undefined) return false;
    if (!('firstProfiles' in value) || value['firstProfiles'] === undefined) return false;
    if (!('profiles' in value) || value['profiles'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function FreelancersListFromJSON(json: any): FreelancersList {
    return FreelancersListFromJSONTyped(json, false);
}

export function FreelancersListFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancersList {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'ownerFullName': json['ownerFullName'] == null ? undefined : json['ownerFullName'],
        'sharedWithinCompany': json['sharedWithinCompany'],
        'firstProfiles': ((json['firstProfiles'] as Array<any>).map(ProfileSummaryFromJSON)),
        'profiles': json['profiles'],
        'count': json['count'],
    };
}

export function FreelancersListToJSON(value?: FreelancersList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'ownerFullName': value['ownerFullName'],
        'sharedWithinCompany': value['sharedWithinCompany'],
        'firstProfiles': ((value['firstProfiles'] as Array<any>).map((v) => ProfileSummaryToJSON(v))),
        'profiles': value['profiles'],
        'count': value['count'],
    };
}

